/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Renders the span element. Elements can have types which fit within a span link Text, Link, etc.
 */
import { Text } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import React from "react";
// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

export const spanRendererTester: RankedTester = rankWith(4, uiTypeIs("Span"));

function SpanRenderer({ uischema, visible }: RendererProps) {
  const { renderers, cells } = useJsonForms();
  const elements = uischema.options?.elements;
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <Text
      data-testid="span"
      {...spectrumProps}
      UNSAFE_style={style}
      isHidden={!componentVisibility}
    >
      {elements.map((element: any, index: number) => (
        <JsonFormsDispatch
          key={index}
          renderers={renderers}
          cells={cells}
          uischema={element}
          schema={{}}
        />
      ))}
    </Text>
  );
}

export default withJsonFormsLayoutProps(SpanRenderer);
